import { type FunctionComponent, useState } from 'react';

import Button from '../../../button/button';
import TextFieldWrapper, {
  type TextFieldWrapperProps,
} from '../../field_wrappers/text/text';

import styles from './email.module.css';

const Email: FunctionComponent<TextFieldWrapperProps> = (props) => {
  const [value, setValue] = useState(props.value);
  return (
    <TextFieldWrapper
      {...props}
      onChange={(currentValue, event) => {
        setValue(currentValue);
        if (props.onChange) {
          props.onChange(currentValue, event);
        }
      }}
      value={props.value}
      validations="isEmail"
      buttonAfter={
        <Button
          className={styles.mailto}
          noBorder
          variant="info"
          iconName="email"
          disabled={!value}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            window.location.href = `mailto:${value}`;
          }}
        />
      }
    />
  );
};

export default Email;
